import React, { Fragment } from "react";
import { Form, Input, DatePicker, Radio, Button } from "antd";

const { Item } = Form; // Destructure Item from Form

const Shop = () => {
  return (
    <Fragment>
      <div className="container mx-auto max-w-md">
        <h1 className="text-2xl text-center my-4">Admission Form</h1>
        <Form
          name="admission_form"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          className="mt-4"
        >
          <Item
            label="Full Name"
            name="fullName"
            rules={[
              { required: true, message: "Please input your full name!" },
            ]}
          >
            <Input />
          </Item>
          <Item
            label="Date of Birth"
            name="dob"
            rules={[
              { required: true, message: "Please select your date of birth!" },
            ]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Item>
          <Item label="Gender" name="gender" rules={[{ required: true }]}>
            <Radio.Group>
              <Radio value="male">Male</Radio>
              <Radio value="female">Female</Radio>
            </Radio.Group>
          </Item>
          <Item
            label="Email Address"
            name="email"
            rules={[
              { required: true, message: "Please input your email address!" },
              { type: "email", message: "Please input a valid email address!" },
            ]}
          >
            <Input />
          </Item>
          <Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Item>
        </Form>
      </div>
    </Fragment>
  );
};

export default Shop;
